import { useState } from 'react';

import { Option, Select } from 'app/components/fields/Select';

export const BrandSelect = ({
  value,
  setSearch,
  onChange,
  experiencesBrands,
}: Props) => {
  const [customBrands, setCustomBrands] = useState<string[]>([]);

  return (
    <Select
      value={value}
      onChange={onChange}
      showSearch
      allowClear
      onSearch={(searchValue) => setSearch(searchValue)}
      onInputKeyDown={(event) => {
        if (event.key === 'Enter') {
          // @ts-ignore -- legacy directive, needs investigation
          const newBrand = event.target.value;

          if (newBrand) {
            setCustomBrands((prevCustomBrands) => [
              ...prevCustomBrands,
              newBrand,
            ]);

            if (onChange) {
              onChange(newBrand);
            }
          }
        }
      }}
    >
      {[...experiencesBrands, ...customBrands].map((brand) => (
        <Option key={brand} value={brand}>
          {brand}
        </Option>
      ))}
    </Select>
  );
};

type Props = {
  value?: string;
  setSearch: (search: string) => void;
  onChange?: (newValue: string) => void;
  experiencesBrands: string[];
};
